<template>
  <div class="main-page-check">
    <div v-if="type == 1" style="font-size: 20px;"><span>邮箱验证</span><span style="color: green;">成功</span>,<span>2秒后自动跳转到首页...</span></div>
    <div v-if="type == 0" style="font-size: 20px;"><span>邮箱验证</span><span style="color: red;">失败</span>,<span style="color: red;">请重试！</span><span>2秒后自动关闭</span></div>
    <div v-if="type == 2" style="font-size: 20px;">正在验证...</div>
  </div>
</template>

<script>
export default {
    name:'ValidateEmail',
    data(){
        return {
            type: 2,
            text_fail:'邮箱验证失败，请重试，2秒后自动关闭页面',
        }
    },
    mounted(){
        
        let code = this.$route.query.code
        this.checkCodeValidate(code)
        setTimeout(()=>{
            window.opener = null;
            window.open("about:blank", "_top").close()
        },4000)
    },
    methods:{
        checkCodeValidate(val){
            let t = new Date().getTime() // 
            this.$request.get('/user/validateEmail',{code:val},false).then(response=>{
                 
                if(response.data.code == 200){
                    this.type = 1
                    console.log('验证成功',response.data.data)
                    let email = response.data.data
                    let t = new Date().getTime() 
                    localStorage.setItem("validateEmailState", 'success_' + email + "_" + t.toString())
        
                }else {
                    this.type = 0
                    // console.log('验证失败',response)
                    localStorage.setItem("validateEmailState",  'fail_' + t.toString())
                }
            }).catch(err=>{
                this.type = 0
                // console.log('验证出错',err)
                localStorage.setItem("validateEmailState",  'error_' + t.toString())
            })
        },
    }
}
</script>

<style scoped>
    .main-page-check{
        display: flex;
        justify-content: center;
        padding-top: 180px;
        width: 100%;
        height: 100vh;
        background: linear-gradient(0deg, white 10%, #97D9FF 100%);
    }
</style>


// WEBPACK FOOTER //
// src/views/login/validateEmail.vue